import React, { useEffect, useRef, useState } from 'react';

export interface RowActionItem {
  id: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface RowActionsMenuProps {
  items: RowActionItem[];
  ariaLabel?: string;
}

export const RowActionsMenu: React.FC<RowActionsMenuProps> = ({ items, ariaLabel = 'Row actions' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={ref} data-row-action>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="btn-surface-muted rounded-lg px-2 py-1 text-xs font-medium"
        aria-expanded={open}
        aria-haspopup="true"
        aria-label={ariaLabel}
      >
        ⋯
      </button>
      {open ? (
        <div
          className="absolute right-0 z-20 mt-1 min-w-[10rem] rounded-lg border border-border bg-surface py-1 shadow-lg"
          role="menu"
        >
          {items.map((item) => (
            <button
              key={item.id}
              type="button"
              role="menuitem"
              disabled={item.disabled}
              onClick={() => {
                setOpen(false);
                item.onClick();
              }}
              className="block w-full px-3 py-2 text-left text-sm text-fg hover:bg-surface-muted disabled:opacity-50"
            >
              {item.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
};
